import request from "@/utils/request";
import { getLocalStorage, setLocalStorage } from "@/utils/local-storage";
// 定义一个全局的键名用于在本地存储中存储visitId
const VISIT_ID_KEY = "saved_visitId";

function accessLog() {
  this.baseUrl = "";
  this.visitId = "0";
  this.time = new Date().getTime();
  // 在构造函数中尝试从本地存储获取之前保存的visitId
  let savedVisitId = getLocalStorage(VISIT_ID_KEY);
  if (savedVisitId) {
      this.visitId = savedVisitId;
  }
}

accessLog.prototype.baseUrl = "";
accessLog.prototype.visitId = "";
accessLog.prototype.setBaseUrl = function(url) {
  if (!accessLog.prototype.baseUrl) accessLog.prototype.baseUrl = url
  this.baseUrl = url;
};

// 滚动条滚动的百分比
function getScrollPercentage() {
  const documentHeight = document.documentElement.scrollHeight;
  const windowHeight = window.innerHeight;
  const scrollTop = window.scrollY;
  
  if (documentHeight <= windowHeight) {
    return 100;
  }
  
  const scrollPercent = (scrollTop / (documentHeight - windowHeight)) * 100;
  const currentPercent = isNaN(scrollPercent) ? 0 : Math.round(scrollPercent);
  
  // 使用静态变量记录最大滚动百分比
  getScrollPercentage.maxPercent = Math.max(currentPercent, getScrollPercentage.maxPercent || 0);
  
  return getScrollPercentage.maxPercent;
}

accessLog.prototype.saveAccessLog = function(uid) {
  let data = new FormData();
  data.append("l", encodeURIComponent(document.referrer));
  data.append("u", encodeURIComponent(window.location.href)); // 使用 href 获取完整的 URL
  data.append("navUA", encodeURIComponent(navigator.userAgent));
  data.append("uid", uid);
  data.append("title", encodeURIComponent(document.title));
  data.append("percentage", getScrollPercentage() || 0);
  
  let _this = this;
  request({
    url: this.baseUrl + "SaveVisitlog",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
    .then(data => {
      accessLog.prototype.visitId = data;
      // 在请求成功更新visitId后，将其保存到本地存储({ VISIT_ID_KEY: _this.visitId })
      setLocalStorage({ VISIT_ID_KEY: _this.visitId });
    })
    .catch(err => {
      console.log(err);
    });
};

accessLog.prototype.closeVisit = function() {
  let second = ((new Date().getTime() - this.time) / 1000) | 0;
  let data = new FormData();
  data.append("visitid", accessLog.prototype.visitId || "0");
  data.append("tjSecond", second.toString());
  data.append("percentage", getScrollPercentage() || 0); // 已阅读网页百分比
  
  request({
    url: accessLog.prototype.baseUrl + "CloseVisit",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  }).then(dataResp=>{}).catch(err => {
    // console.log(err);
  });
};

// 创建一个实例并设置定时器
const log = new accessLog();
log.time = new Date().getTime(); // 初始化时间

// 每隔10秒执行一次 closeVisit 方法
setInterval(function() {
  log.closeVisit();
}, 20000); // 10000 毫秒 = 10 秒

export default accessLog;